import styled from "styled-components";

export default function WizardCard({ children, title }) {
  return (
    <Card>
      {title && <CardTitle>{title}</CardTitle>}
      {children}
    </Card>
  );
}

const Card = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`;
